
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { useState, useEffect } from 'react';
import { TransactionSummaryItem, RECENT_ACTIVITY } from '../data/recent-transactions';

export const useTransactionSummary = () => {
    const [transactions, setTransactions] = useState<TransactionSummaryItem[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simulate real-time fetch
        const fetchTransactions = async () => {
            setLoading(true);
            await new Promise(r => setTimeout(r, 800));
            setTransactions(RECENT_ACTIVITY);
            setLoading(false);
        };

        fetchTransactions();

        // Simulate live updates
        const interval = setInterval(() => {
            const newItem: TransactionSummaryItem = {
                id: `tx_${Date.now()}`,
                type: Math.random() > 0.6 ? 'SWAP' : 'MINT',
                user: `User${Math.floor(Math.random() * 9000)}`,
                description: 'Just executed a trade',
                amount: (Math.random() * 1000).toFixed(2),
                tokenSymbol: Math.random() > 0.5 ? 'SOL' : 'SUI',
                timestamp: Date.now(),
                chain: Math.random() > 0.5 ? 'SOL' : 'SUI',
                status: 'SUCCESS',
                hash: '0x...'
            };
            setTransactions(prev => [newItem, ...prev].slice(0, 10));
        }, 8000);

        return () => clearInterval(interval);
    }, []);

    return { transactions, loading };
};
